import { render, staticRenderFns } from "./InputTag.vue?vue&type=template&id=4896587c"
import script from "./InputTag.vue?vue&type=script&lang=js"
export * from "./InputTag.vue?vue&type=script&lang=js"
import style0 from "./InputTag.vue?vue&type=style&index=0&id=4896587c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports